import { styled } from "sharedUI/styles";

export const PaymentInfoModalStyle = styled.div<{ padTop: boolean; cardFocused: boolean }>`
    display: flex;
    flex-direction: column;

    padding-top: ${p => (p.padTop ? 16 : 0)}px;

    .title-with-cancel {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .error-message {
        border-radius: 9px;
        margin-top: 10px;
        color: ${p => p.theme.r500};
        font-size: 13px;
        padding: 12px;
        background-color: ${p => p.theme.r100};

        .error-title {
            font-weight: 600;
            margin-bottom: 4px;
        }

        .error-msg {
            font-weight: 400;
            opacity: 0.75;
            a {
                cursor: pointer;
                text-decoration: underline !important;
            }
        }
    }

    .payment-info-label,
    .send-to-label {
        font-size: 14px;
        font-weight: 700;
        color: ${p => p.theme.textBase};
    }

    .cardWrapper {
        border: 1px solid ${p => (p.cardFocused ? p.theme.accentPrimary : p.theme.borderColor)};
        padding: 6px 12px;
        height: 36px;
        border-radius: 5px;
        margin: 10px 0px 6px 0px;

        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .stripe {
        margin-top: 6px;
        align-self: flex-end;
        color: ${p => p.theme.textBase};
        opacity: 0.5;
    }

    .form-input {
        border: 1px solid ${p => p.theme.borderColor};
        padding: 8px 12px;
        border-radius: 5px;
        font-size: 14px;
        margin: 6px 0px 6px 0px;
        color: ${p => p.theme.fgColorDark};
        background-color: transparent;

        :focus {
            border-color: ${p => p.theme.accentPrimary};
        }
    }

    .form-error {
        font-size: 12px;
        color: ${p => p.theme.destroyColor};
        margin-top: -10px;
        margin-bottom: 8px;
    }

    .city-zip-container {
        display: grid;
        grid-template-columns: minmax(0, 5fr) minmax(0, 2fr) minmax(0, 3fr);

        > *:not(:last-child) {
            margin-right: 8px;
        }
    }

    .form-input-country {
        margin: 8px 0px 8px 0px;
        font-size: 14px;
        border: 1px solid ${p => p.theme.borderColor};
        padding: 6px 12px;
        height: 36px;
        border-radius: 5px;
        background: transparent;
        appearance: none;
        background-image: url("data:image/svg+xml;utf8,<svg fill='grey' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
        background-repeat: no-repeat;
        background-position-x: 98%;
        background-position-y: 5px;

        :focus {
            border-color: ${p => p.theme.accentPrimary};
        }
    }

    .emailInput {
        margin-bottom: 0px;
    }
`;
